"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var utils_1 = require("../../../utils");
var Card_1 = require("../../Card");
var FormControl_1 = __importDefault(require("../../FormControl"));
var RadioInput_1 = __importDefault(require("../../RadioInput"));
var Select_1 = __importDefault(require("../../Select"));
var Tabs_1 = require("../../Tabs/Tabs");
var errorKeys = ['ethnicity', 'sub_ethnicity', 'language', 'interpreter', 'religion'];
var EthnicityDetailsForm = function (_a) {
    var tabId = _a.tabId;
    var _b = context_1.useSemantics(), trans = _b.trans, options = _b.options;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _c = formik_1.useFormikContext(), values = _c.values, errors = _c.errors;
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(errors, errorKeys)); }, [errors]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('optiiva::headings.ethnicity'), subHeading: trans('optiiva::headings.details') },
        react_1.default.createElement(FormControl_1.default, { errors: errors.ethnicity, dusk: "ethnicity-field", label: trans('optiiva::labels.ethnicity'), showOther: !!values.ethnicity, other: react_1.default.createElement(FormControl_1.default, { errors: errors.sub_ethnicity, label: trans('optiiva::labels.sub-ethnicity') },
                react_1.default.createElement(Select_1.default, { width: "sm", options: options.subEthnicities(values.ethnicity || undefined), name: "sub_ethnicity" })) },
            react_1.default.createElement(Select_1.default, { options: options.ethnicities(), name: "ethnicity" })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.religion, dusk: "religion-field", label: trans('optiiva::labels.religion') },
            react_1.default.createElement(Select_1.default, { width: "sm", options: options.religions(), name: "religion" })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.language, dusk: "language-field", label: trans('optiiva::labels.language') },
            react_1.default.createElement(Select_1.default, { width: "sm", options: options.languages(), name: "language" })),
        react_1.default.createElement(FormControl_1.default, { errors: errors.interpreter, dusk: "interpreter-field", label: trans('optiiva::labels.interpreter-required'), flush: true }, (function () {
            var opts = options.boolean();
            return Object.keys(opts).map(function (key) { return (react_1.default.createElement(RadioInput_1.default, { key: "interpreter-" + key, name: "interpreter", label: opts[key], value: key })); });
        })())));
};
exports.default = EthnicityDetailsForm;
//# sourceMappingURL=EthnicityDetailsForm.js.map